import Actions from './actions';
var Creators = Actions.Creators;
var receiveErrorOperation = Creators.receiveError;
var resetErrorOperation = Creators.resetError;

var receiveError = function receiveError(error, handler) {
  return function (dispatch, getState) {
    return dispatch(receiveErrorOperation(error, handler));
  };
};

var resetError = function resetError(error, handler) {
  return function (dispatch, getState) {
    return dispatch(resetErrorOperation());
  };
};

export default {
  receiveError: receiveError,
  resetError: resetError
};